<script setup>
import { ref } from 'vue';
import { PhotoIcon, CheckIcon } from '@heroicons/vue/24/solid'
import { useAgencesStore } from '../stores/agences';
import { useClientsStore } from '../stores/clients';
import { Switch, SwitchGroup, SwitchLabel } from '@headlessui/vue'
import DropZone from '../components/DropZone.vue'
import FilePreview from '../components/FilePreview.vue'
import useFileList from '../compositions/file-list'
import Toast from '../components/Toast.vue';
import { data } from 'autoprefixer';
import moment from 'moment/moment';

// #region VARIABLES

const agenceStore = useAgencesStore();
const clientsStore = useClientsStore();
const { files, addFiles, removeFile } = useFileList()
const loadingCreate = ref(false)

const dataCreation = ref({
    idAgence_cli: 0,
    ref_cli: '',
    refHist_cli: '',
    nom_cli: '',
    pNoms_cli: '',
    sexe_cli: '0',
    type_cli : 'adherent',
    duree_cli: 12,
    adr_cli : '',
    cp_cli : '',
    ville_cli : '',
    telPri_cli : '',
    affTelPri_cli : 0,
    telPro_cli : '',
    affTelPro_cli : 0,
    telGsm_cli : '',
    affTelGsm_cli : 0,
    mail_cli : '',
    nl_cli : 0,
    situation_cli: {
        celib_cli: false,
        veuf_cli: false,
        div_cli: false,
        sep_cli: false,
        instDiv_cli: false,
    },
    libre_cli: 1,
    taille_cli: '',
    poid_cli: '',
    cheveux_cli: 0,
    yeux_cli: 0,
    lun_cli: false,
    sante_cli: '',
    def_cli: '',
    rem_cli: '',
    interets_cli: '',
    milieu_cli: '',
    desc_cli: '',
    prof_cli: '',
    tranche_cli: '',
    hor_cli: '',
    veh_cli: '',
    permis_cli: false,
    loge_cli: 0,
    ms_cli: '_3',
    desCelib_cli: 1,
    desVeuf_cli: 1,
    desDiv_cli: 1,
    desSep_cli: 1,
    desAge_cli_min: 18,
    desAge_cli_max: 0,
    desNbEn_cli: 0,
    desPhy_cli: '',
    desCaract_cli: '',
    desReg_cli: 0,
    desInst_cli: 0,
    desProf_cli: 0,
    desCarctIndisp_cli: '',
    msRech_cli: '_3',
    msRechPrec_cli: '',
    affAnn_cli: 'N',
    dateRev_cli: moment().add(21, 'days').format('YYYY-MM-DD'),
    visu_cli: 'public'
});

const stateToast = ref(false);
const newlyClient = ref(0);
// #endregion

// #region METHODS
const handleCreationFiche = () => {
    loadingCreate.value = true;
    dataCreation.value.refHist_cli = dataCreation.value.ref_cli;

    clientsStore.createClient(dataCreation.value, files.value)
    .then(res => {
        stateToast.value = true;
        loadingCreate.value = false;
        if(res.arr){
            newlyClient.value = res.arr.id_cli
            dataCreation.value = {
                idAgence_cli: 0,
                ref_cli: '',
                nom_cli: '',
                pNoms_cli: '',
                sexe_cli: '0',
                type_cli : 'adherent',
                duree_cli: 12,
                adr_cli : '',
                cp_cli : '',
                ville_cli : '',
                telPri_cli : '',
                affTelPri_cli : 0,
                telPro_cli : '',
                affTelPro_cli : 0,
                telGsm_cli : '',
                affTelGsm_cli : 0,
                mail_cli : '',
                nl_cli : 0,
                situation_cli: {
                    celib_cli: false,
                    veuf_cli: false,
                    div_cli: false,
                    sep_cli: false,
                    instDiv_cli: false,
                },
                libre_cli: 1,
                taille_cli: '',
                poid_cli: '',
                cheveux_cli: 0,
                yeux_cli: 0,
                lun_cli: false,
                sante_cli: '',
                def_cli: '',
                rem_cli: '',
                interets_cli: '',
                milieu_cli: '',
                desc_cli: '',
                prof_cli: '',
                tranche_cli: '',
                hor_cli: '',
                veh_cli: '',
                permis_cli: false,
                loge_cli: 0,
                ms_cli: '_3',
                desCelib_cli: 0,
                desVeuf_cli: 0,
                desDiv_cli: 0,
                desSep_cli: 0,
                desAge_cli_min: 0,
                desAge_cli_max: 0,
                desNbEn_cli: 0,
                desPhy_cli: '',
                desCaract_cli: '',
                desReg_cli: 0,
                desInst_cli: 0,
                desProf_cli: 0,
                desCarctIndisp_cli: '',
                msRech_cli: '_3',
                msRechPrec_cli: '',
                dateRev_cli: moment().add(7, 'days').format('YYYY-MM-DD'),
                visu_cli: 'public'
            }

            files.value = [];
        }
    })
    .catch(err => console.error(err))
}

const onInputChange = (e) => {
    addFiles(e.target.files)
	e.target.value = null
}
// #endregion 

</script>

<template>
    <div class="h-screen flex-1 sm:p-10 p-5 overflow-y-auto">
        <form method="POST" @submit.prevent="handleCreationFiche" class="bg-gray-50 sm:p-10 p-5 mt-4 rounded-xl">
            <div class="space-y-12">
                <TransitionGroup class="overflow-hidden" tag="div" name="deploy">
                    <div class="grid grid-cols-1 gap-x-8 gap-y-10 border-b border-gray-900/10 pb-12 md:grid-cols-3">
                        <div>
                            <h2 class="text-base font-semibold leading-7 text-gray-900">Référence de la fiche</h2>
                            <p class="mt-1 text-sm leading-6 text-gray-600">Élements de base pour créer et réferencer une fiche client.</p>
                        </div>

                        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2 bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl px-4 py-6 sm:p-8">
                            <div v-if="agenceStore.agences" class="sm:col-span-full">
                                <label for="idAgence_cli" class="block text-sm font-medium leading-6 text-gray-900">Agence</label>
                                <div class="mt-2">
                                    <select id="idAgence_cli" name="idAgence_cli" v-model="dataCreation.idAgence_cli" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6">
                                        <option v-for="agence in agenceStore.agences" :value="agence.id_agence">
                                            {{ agence.lib_agence }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="sm:col-span-full">
                                <label for="ref_cli"
                                    class="block text-sm font-medium leading-6 text-gray-900">Référence</label>
                                <div class="mt-2">
                                    <input type="text" name="ref_cli"
                                        id="ref_cli"
                                        v-model="dataCreation.ref_cli"
                                        required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="col-span-full">
                                <label for="cover-photo" class="block text-sm font-medium leading-6 text-gray-900">Photo de profil</label>
                                
                                <DropZone class="drop-area" @files-dropped="addFiles" #default="{ dropZoneActive }">
                                    <div v-show="!files.length" :class="[dropZoneActive ? 'border-solid border-rose' : 'border-dashed','mt-2 flex justify-center rounded-lg border border-gray-900/25 px-6 py-10']">
                                        <div class="text-center">
                                            <PhotoIcon class="mx-auto h-12 w-12 text-gray-300" aria-hidden="true" />
                                            <div class="mt-4 flex text-sm leading-6 text-gray-600">
                                                <label for="file-upload" class="relative cursor-pointer rounded-md bg-white font-semibold text-rose-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-rose-600 focus-within:ring-offset-2 hover:text-rose-500">
                                                    <span>Téléverser une image</span>
                                                    <input id="file-upload" @change="onInputChange" name="file-upload" type="file" class="sr-only" />
                                                </label>
                                                <p class="pl-1">ou glisser, déposer</p>
                                            </div>
                                            <p class="text-xs leading-5 text-gray-600">PNG, JPG, GIF jusqu'à 10 Mo</p>
                                        </div>
                                    </div>

                                    <div class="flex justify-center" v-show="files.length">
                                        <FilePreview v-for="file of files" :key="file.id" :file="file" tag="figure" @remove="removeFile" />
                                    </div>
                                </DropZone>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="pNoms_cli"
                                    class="block text-sm font-medium leading-6 text-gray-900">Prénom(s)</label>
                                <div class="mt-2">
                                    <input type="text" name="pNoms_cli"
                                        id="pNoms_cli"
                                        v-model="dataCreation.pNoms_cli"
                                        required
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="nom_cli" class="block text-sm font-medium leading-6 text-gray-900">Nom de famille</label>
                                <div class="mt-2">
                                    <input type="text" name="nom_cli" id="nom_cli" required v-model="dataCreation.nom_cli"
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="dateNaiss_cli"
                                    class="block text-sm font-medium leading-6 text-gray-900">Naissance</label>
                                <div class="mt-2">
                                    <input id="dateNaiss_cli" name="dateNaiss_cli" type="date" v-model="dataCreation.dateNaiss_cli"
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                </div>
                            </div>

                            <div class="sm:col-span-3">
                                <label for="sexe_cli"
                                    class="block text-sm font-medium leading-6 text-gray-900">Sexe</label>
                                <div class="mt-2">
                                    <select
                                        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:max-w-xs sm:text-sm sm:leading-6"
                                        v-model="dataCreation.sexe_cli"
                                        name="sexe_cli"
                                        id="sexe_cli"
                                        >
                                        <option value="0">Inderterminé</option>
                                        <option value="F">Femme</option>
                                        <option value="H">Homme</option>
                                    </select>
                                </div>
                            </div>

                            <div class="sm:col-span-2 self-end mb-2">
                                <SwitchGroup as="div" class="flex items-center">
                                    <Switch value="1" v-model="dataCreation.situation_cli.celib_cli"
                                        :class="[dataCreation.situation_cli.celib_cli ? 'bg-rose-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-rose-600 focus:ring-offset-2']">
                                        <span aria-hidden="true"
                                            :class="[dataCreation.situation_cli.celib_cli ? 'translate-x-5' :  'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                    </Switch>
                                    <SwitchLabel as="span" class="ml-3 text-sm">
                                        <span class="font-medium text-gray-900">Célibataire</span>
                                    </SwitchLabel>
                                </SwitchGroup>
                            </div>
                            <div class="sm:col-span-2 self-end mb-2">
                                <SwitchGroup as="div" class="flex items-center">
                                    <Switch v-model="dataCreation.situation_cli.veuf_cli"
                                        :class="[dataCreation.situation_cli.veuf_cli ? 'bg-rose-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-rose-600 focus:ring-offset-2']">
                                        <span aria-hidden="true"
                                            :class="[dataCreation.situation_cli.veuf_cli ? 'translate-x-5' :  'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                    </Switch>
                                    <SwitchLabel as="span" class="ml-3 text-sm">
                                        <span class="font-medium text-gray-900">Veuf</span>
                                    </SwitchLabel>
                                </SwitchGroup>
                            </div>
                            <div class="sm:col-span-2 self-end mb-2">
                                <SwitchGroup as="div" class="flex items-center">
                                    <Switch v-model="dataCreation.situation_cli.div_cli"
                                        :class="[dataCreation.situation_cli.div_cli ? 'bg-rose-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-rose-600 focus:ring-offset-2']">
                                        <span aria-hidden="true"
                                            :class="[dataCreation.situation_cli.div_cli ? 'translate-x-5' :  'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                    </Switch>
                                    <SwitchLabel as="span" class="ml-3 text-sm">
                                        <span class="font-medium text-gray-900">Divorcé</span>
                                    </SwitchLabel>
                                </SwitchGroup>
                            </div>
                            <div class="sm:col-span-2 self-end mb-2">
                                <SwitchGroup as="div" class="flex items-center">
                                    <Switch v-model="dataCreation.situation_cli.sep_cli"
                                        :class="[dataCreation.situation_cli.sep_cli ? 'bg-rose-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-rose-600 focus:ring-offset-2']">
                                        <span aria-hidden="true"
                                            :class="[dataCreation.situation_cli.sep_cli ? 'translate-x-5' :  'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                    </Switch>
                                    <SwitchLabel as="span" class="ml-3 text-sm">
                                        <span class="font-medium text-gray-900">Séparé</span>
                                    </SwitchLabel>
                                </SwitchGroup>
                            </div>
                            <div class="sm:col-span-4 self-end mb-2">
                                <SwitchGroup as="div" class="flex items-center">
                                    <Switch v-model="dataCreation.situation_cli.instDiv_cli"
                                        :class="[dataCreation.situation_cli.instDiv_cli ? 'bg-rose-600' : 'bg-gray-200', 'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-rose-600 focus:ring-offset-2']">
                                        <span aria-hidden="true"
                                            :class="[dataCreation.situation_cli.instDiv_cli ? 'translate-x-5' :  'translate-x-0', 'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out']" />
                                    </Switch>
                                    <SwitchLabel as="span" class="ml-3 text-sm">
                                        <span class="font-medium text-gray-900">Instance de divorce</span>
                                    </SwitchLabel>
                                </SwitchGroup>
                            </div>

                            <div class="sm:col-span-full">
                                <label for="type_cli" class="block text-sm font-medium leading-6 text-gray-900">Type de contrat</label>
                                <div class="mt-2">
                                    <select id="type_cli" name="type_cli" v-model="dataCreation.type_cli" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6">
                                        <option value="adherent">Nouvel adhérent</option>
                                        <option value="contact">Contact</option>
                                        <option value="prospect">Prospect</option>
                                    </select>
                                </div>
                            </div>

                            <div class="sm:col-span-full" v-if="dataCreation.type_cli === 'adherent'">
                                <label for="duree_cli" class="block text-sm font-medium leading-6 text-gray-900">Durée du contrat</label>
                                <div class="mt-2">
                                    <div class="flex items-center rounded-md bg-white px-3 outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-rose-500">
                                        <input type="number" min="1" max="12" name="duree_cli" id="duree_cli" required v-model="dataCreation.duree_cli" class="block min-w-0 border-0 grow py-1.5 pl-1 pr-3 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6" placeholder="0.00" aria-describedby="price-currency" />
                                        <div class="shrink-0 select-none text-base text-gray-500 sm:text-sm/6">mois</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TransitionGroup>
            </div>

            <div class="flex flex-wrap justify-end items-center mt-6">
                <div class="flex items-center justify-end gap-x-6">
                    <button type="submit" :class="[loadingCreate ? 'animate-pulse pointer-events-none' : 'pointer-events-auto' , 'rounded-md bg-rose-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-rose-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600 duration-300 ease-out']">Enregistrer</button>
                </div>
            </div>
        </form>
        
        <Toast :state="stateToast" title="Fiche client ajoutée">
            <router-link :to="{name: 'Client', params: {id: newlyClient}}" class="inline-block rounded-md px-3 py-2 text-sm font-semibold text-white hover:text-black duration-300 ease-out">
                Voir la fiche
            </router-link>
        </Toast>
    </div>
</template>

<style scoped>
    .deploy-enter-active,
    .deploy-leave-active {
        transition: all 0.5s ease;
    }

    .deploy-enter-from,
    .deploy-leave-to {
        opacity: 0;
        height: 0;
        padding: 0;
    }
</style>